import React from 'react';
import SpeakAboutThePhoto from '../components/SpeakAboutThePhoto';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function SpeakAboutThePhotoPage() {
  return (
    <>
      <Navbar />
      <SpeakAboutThePhoto />
      <Footer />
    </>
  );
}
